import { render, staticRenderFns } from "./SeaTourDetail.vue?vue&type=template&id=278d8215&scoped=true&"
import script from "./SeaTourDetail.vue?vue&type=script&lang=js&"
export * from "./SeaTourDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278d8215",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('278d8215')) {
      api.createRecord('278d8215', component.options)
    } else {
      api.reload('278d8215', component.options)
    }
    module.hot.accept("./SeaTourDetail.vue?vue&type=template&id=278d8215&scoped=true&", function () {
      api.rerender('278d8215', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/seatour/SeaTourDetail.vue"
export default component.exports